import React from 'react';
import cx from 'classnames';

import GenericStateBlock from '../../blocks/GenericStateBlock';

import styles from './AccountExpiredPage.module.scss';
import usePresenter from './AccountExpiredPage.presenter';
import getProps from './AccountExpiredPage.props';
import { AccountExpiredPageCombinedProps } from './types';


const AccountExpiredPage: React.FC<AccountExpiredPageCombinedProps> = (props) => {
  const {
    className,
    classes,
    genericStateBlock,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.accountExpiredPage;

  return (
    <div className={cx(currentStyle, className)}>
      <GenericStateBlock
        className={cx(styles.genericStateBlock, classes?.genericStateBlock)}
        {...internalProps.genericStateBlock}
        {...genericStateBlock}/>
    </div>
  );
};

export default AccountExpiredPage;

